'use client'

import { useEffect } from 'react'
import { useRouter } from 'next/navigation'

export default function OAuthUserSetup() {
  const router = useRouter()

  useEffect(() => {
    // Check if there's an OAuth setup cookie
    const cookies = document.cookie.split(';')
    const oauthCookie = cookies.find(cookie => cookie.trim().startsWith('oauth_user_setup='))
    
    if (oauthCookie) {
      try {
        const cookieValue = oauthCookie.split('=')[1]
        const userData = JSON.parse(decodeURIComponent(cookieValue))
        
        // Create the user object structure that the frontend expects
        const userObject = {
          userInfo: {
            user: {
              email: userData.email,
              firstName: userData.firstName,
              lastName: userData.lastName,
              userId: userData.userId, // Use the actual database userId
              avatarUrl: userData.avatarUrl,
              agencyId: userData.agencyId,
              roleName: userData.roleName,
              // Add company fields
              companyName: userData.companyName || '',
              industry: userData.industry || '',
              numOfEmployees: userData.numOfEmployees || '',
              aiUsageIntent: userData.aiUsageIntent || [],
              businessRole: userData.businessRole || '',
              dataStorageLocation: userData.dataStorageLocation || '',
              subscriptionId: userData.subscriptionId,
              subscriptionStatus: userData.subscriptionStatus,
              stripeCustomerId: userData.stripeCustomerId,
              agreeToTerms: userData.agreeToTerms,
              businessTrial: userData.businessTrial
            },
            session: {
              access_token: 'oauth_token', // Placeholder - real token is in Supabase cookies
              user: {
                id: userData.userId, // Use actual userId
                email: userData.email
              }
            }
          },
          agencyUser: {
            id: userData.agencyUserId,
            agencyId: userData.agencyId,
            roleName: userData.roleName || 'AGENCY_OWNER',
            Permissions: userData.permissions
          }
        }
        
        // Set the user data in localStorage
        localStorage.setItem('user', JSON.stringify(userObject))
        
        // Remove the temporary cookie
        document.cookie = 'oauth_user_setup=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
        
        // Emit a custom event to notify components that user data has been updated
        window.dispatchEvent(new CustomEvent('userDataUpdated', { detail: userObject }))
        
      } catch (error) {
        console.error('Error setting up OAuth user data:', error)
      }
    }
  }, [router])

  return null // This component doesn't render anything
} 